import type { TPromoRelease } from '@core/models'

/** Titles of the releases worth warning about — an untitled one has nothing to show the user. */
export const getPromoReleaseNames = (releases: TPromoRelease[]) => {
    return releases.map(release => release.collection?.title ?? '').filter(name => name !== '')
}
